import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// import "echarts"
// import Echarts from "vue-echarts"
// Vue.component("Echarts", Echarts)

import { requireImg } from '@/utils/requireImg';
Vue.prototype.requireImg = requireImg;

import '@/assets/css/common.scss';

import Loading from 'element-ui/lib/loading';
Vue.use(Loading.directive);

import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
Vue.use(VXETable);

import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Element);

import http from '@/lib/js/http';

Vue.prototype.$http = http;
Vue.prototype.$store = store;
import axios from 'axios';
Vue.prototype.$axios = axios;
// Vue.prototype.S = localStorage
Vue.prototype.$err = Vue.prototype.$message.error;
Vue.prototype.$suc = Vue.prototype.$message.success;
Vue.prototype.$log = console.log;

Vue.prototype.$getOss = () => {
  return new Promise((resolve, reject) => {
    if (store.state.oss.key) {
      return resolve(store.state.oss);
    }
    http('get tool/oss')
      .then((res) => {
        if (res.code !== 200) {
          return;
        }
        store.commit('oss', res.data);
        resolve(store.state.oss);
      })
      .finally((res) => {});
  });
};
Vue.prototype.$upload = (event) => {
  console.log(65, event);

  let oss = store.state.oss;
  console.log(68, oss);

  const flie = event.file;
  // 在这里进行一系列的校验
  const formData = new FormData();
  let urlPath = 'laidong/' + Date.now() + Math.random();

  formData.append('key', urlPath);
  formData.append('policy', oss.policyBase64);
  formData.append('OSSAccessKeyId', oss.key);
  formData.append('signature', oss.signature);
  formData.append('success_action_status', 200);
  formData.append('cache-control', 'public');

  formData.append('file', flie);
  return axios
    .post(oss.endpoint, formData, {
      'Content-type': 'multipart/form-data',
    })
    .then(
      (res) => {
        // 上传成功后的处理
        console.log(81, res);
      },
      (err) => {
        // 出现错误时的处理
      }
    );
};
Vue.prototype.$timeFormat = function (timestamp, fmt = 'yyyy-MM-dd') {
  //author: meizz
  let date = new Date(Number(timestamp) * 1000);
  var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  return fmt;
};


import ggUpload from './components/ggUpload.vue'
Vue.use('gg-upload',ggUpload)

let hostData = {
  title: '上岸智路',
  company: '杭州上岸智路信息服务有限公司',
  ipc: '浙ICP备2025153815号-5',
};
let host = location.host;

// host="www.yulianxinxi.cn"

switch (host) {
  case 'www.sazhilu.com':
  case 'sazhilu.com':
    hostData = {
      title: '上岸智路',
      company: '杭州上岸智路信息服务有限公司',
      ipc: '浙ICP备2025153815号-5',
    };
    break;
  case 'www.yulianxinxi.cn':
  case 'yulianxinxi.cn':
    hostData = {
      title: '羽联信息',
      company: '杭州羽联信息科技有限公司',
      ipc: '浙ICP备2023038821号-1 增值电信业务经营许可证 浙B2-20200632',
    };
    break;
  case 'www.hangzhoufujing.cn':
  case 'hangzhoufujing.cn':
    hostData = {
      title: '芙槿科技',
      company: '杭州芙槿科技有限公司',
      ipc: '浙ICP备2025210207号',
    };
    break;
}

Vue.prototype.$hostData = hostData;
// 动态添加<title>标签（不推荐）
var newTitle = document.createElement('title');
newTitle.textContent = hostData.title;
document.head.appendChild(newTitle);
Vue.mixin({
  methods:{
    $logout(){
      this.$store.commit('userInfo', null);
      localStorage.removeItem('token')
      location.href=location.origin
    }
  },
})
new Vue({
  
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
